import styles from './App.module.css';
import AppRouter from './app/providers/router/ui/AppRouter';
import backgroundImgWEBP from './shared/assets/images/backgroundWEBP.webp';
import backgroundImgPNG from './shared/assets/images/backgroundPNG.png';
import { Bounce, ToastContainer } from 'react-toastify';
import './entities/passwordReset/init';
import './features/LoginForm/init';
import './features/ResetPassword/init';
import './features/ChangePassword/init';


function App() {
    return (
        <div className={styles.App}>
            <AppRouter />
            <div className={styles.background}>
                <picture>
                    <source srcSet={backgroundImgWEBP} type='image/webp' />
                    <img className={styles.backgroundImg} src={backgroundImgPNG} alt='background' />
                </picture>
            </div>
            <ToastContainer
                containerId="toasts__container"
                className='toasts__container'
                toastClassName={'toast'}
                position="top-right"
                autoClose={5000}
                limit={3}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
        </div>
    );
}

export default App;
